// @flow
import { connect } from 'react-redux';
import PrivacyPolicy from '../components/PrivacyPolicy';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
  }
}

export default connect(mapStateToProps)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/modules/privacy-policy/containers/PrivacyPolicyContainer.js